import React, { useEffect, useState } from "react";
import find from "lodash/find";
import { useSelector } from "react-redux";
import {
  selectCustomerId,
  selectLanguageSlug,
  selectAuthReducer
} from "../../../util/selectors";
import { POST_MESSAGE } from "@/constants";

const DynamicGamification = ({ bannerData, generalData }) => {
  const [isIframeError, setIsIframeError] = useState(false);
  const [isUrlValid, setIsUrlValid] = useState(false);

  const src = (find(bannerData, { key: "iframeURL" }) || {}).value;

  if (!src) {
    return null;
  }
  const languageSlug = useSelector(selectLanguageSlug);
  const customerId = useSelector(selectCustomerId);
  const userInfo = useSelector(selectAuthReducer);
  const userPhone = userInfo.phone;

  const formattedPhoneNumber = userPhone
    ? userPhone.startsWith("+")
      ? userPhone
      : `+${userPhone}`
    : "";

  const toBase64 = value => (value ? btoa(value.toString()) : "");
  const platform = "web";

  const joinChar = src.includes("?") ? "&" : "?";
  let finalUrl = `${src}${joinChar}lang=${languageSlug}&platform=${platform}`
    .replace("api__customerId__", customerId)
    .replace("api__email__", userInfo.email)
    .replace("api__mobileNumber__", userInfo.phone)
    .replace("api__encodedMobileNumber__", toBase64(formattedPhoneNumber))
    .replace("api__accessToken__", userInfo.accessToken || "");

  const styles = {
    ...generalData.styles,
    maxWidth: generalData.width?.value || "100%",
    margin: `${generalData.styles.marginTop}px auto ${generalData.styles.marginBottom}px`,
    height: "90vh"
  };

  useEffect(() => {
    const setMessageHandler = event => {
      if (event.data.type === POST_MESSAGE.IFRAME_ERROR) {
        setIsIframeError(true);
      }
    };
    window.addEventListener("message", setMessageHandler);

    return () => {
      window.removeEventListener("message", setMessageHandler);
    };
  }, []);

  useEffect(() => {
    const checkUrl = () => {
      try {
        new URL(finalUrl);
        setIsUrlValid(true);
      } catch (error) {
        setIsIframeError(true);
      }
    };

    checkUrl();
  }, [finalUrl]);

  return !isIframeError && isUrlValid ? (
    <div className="gamification_wrapper" style={styles}>
      <iframe
        width="100%"
        height="100%"
        src={finalUrl}
        style={{ border: "none", overflow: "none" }}
      />
    </div>
  ) : null;
};

export default DynamicGamification;
